import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import MUIDataTable, {
  MUIDataTableColumnDef,
  MUIDataTableOptions,
} from "mui-datatables";
import AuthService from "../../auth/AuthService";
import {
  productDownload,
  getAnnualBidInfo,
  annualMyBidProducts,
  annualBidUrl,
  annualMyLatestBidsForUser,
  productUrl,
  annualMyRecentBidsForUser,
} from "../../../common/config/app.endpoints";
import Alert from "../../../common/elements/Alert";
import LoadingSpinner from "../../../common/elements/LoadingSpinner";
import { oAuth } from "../../../routes/basic/BasicAppRouter";
import {
  StyledButton,
  StyledModal,
} from "../../../common/materials/GenericStyleComponent";
import { MuiThemeProvider } from "@material-ui/core/styles";
import update from "immutability-helper";
import moment from "moment";
import { StyledButtonGray } from "../../../common/materials/GenericStyleMuitable";
import { openCertificateLinkPopup } from "../../../common/GenericFunctions";
import EllipsisText from "../../../common/elements/EllipsisText";
import {
  createTheme,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import copy from "copy-to-clipboard";
import { faEdit, faHeart, faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ColorLensIcon from "@material-ui/icons/ColorLens";
import { useTranslation } from "react-i18next";
import PubSub from "pubsub-js";
import AlertReadOnlyUser from "../../../common/elements/AlertReadOnlyUser";
import {
  convertedValue,
  convertedbuyItNowValue,
  getMyLatestStoredBids,
  getRapNet,
  getReturnMyLatestStoredBid,
} from "../../products/preview/TenderGenericFunc";
import {
  StyledButtonView,
  StyledButtonViewFilter,
  Styledview,
} from "../../products/preview/TendorPreviewView";
import {
  StyeldShowAllcontainer,
  StyledshowAllButton,
} from "../../products/preview/TendorJewelleryMyBids";
import ProductBiddingUi from "./biddingUi/ProductBiddingUi";
import Countdown from "react-countdown";
import AnnualBidPopup from "../../products/preview/bidPopupComponent/AnnualBidPopup";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import MybidsAnnualActionPageSize from "../../core-grid/grid-actions/MybidsAnnualActionPageSize";
import {
  isMyBidstabSelected,
  setIsMybids,
} from "../../../redux/slice/commanPagination/commanPaginationSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/reducer";
import {
  selectGridView,
  setIsGridView,
  resetIsGridView,
  setColorFilter,
  selectedColorFilter,
  resetDiamondGridProductIndexes,
  resetDiamondSelectAll,
  setDiamondGridProductIndexes,
  setDiamondSelectAll,
} from "../../../redux/slice/annual/commanAnnualSlice";
import { AppDispatch } from "../../../redux/store";
import ProductGridDataParentMybids from "./mobileUi/ProductGridDataParentMybids";
import {
  StyledBuyitNow,
  StyledIconImg,
  StyledSelectAllButtonHeader,
} from "./DiamondProductStyle";
import ProductGridDataChildComponentMyBids from "./mobileUi/ProductGridDataChildComponentMyBids";
import BuyItNowconfirmation from "./BuyItNow/BuyItNowconfirmation";
const faEditProps = faEdit as IconProp;
const faHeartProps = faHeart as IconProp;
const faShareSquareProps = faShare as IconProp;

const StyledHeaderContainer = styled(Grid)`
  padding-top: 0px;
`;
const StyledLayoutGridMain = styled(Grid)`
  .icon {
    width: 2.8em;
    height: 2.8em;
  }
  width: 100%;
  padding: 5px;
  .MuiIconButton-edgeEnd {
    display: contents !important;
    transition: width 5s !important;
  }
  .MuiAccordionSummary-root {
    min-height: 10px !important;
    transition: width 4s !important;
  }
  .MuiPaper-root {
    box-shadow: none !important;
  }

  .AccordionHeader {
    width: 100%;
    transition: width 1s;
    @keyframes fadeMe {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    ${(props) => props.theme.breakpoints.down("md")} {
      width: 100%;
    }
    ${(props) => props.theme.breakpoints.between("xs", "md")} {
      top: 48px;
      width: 100% !important;
    }
    ${(props) => props.theme.breakpoints.between("lg", "xl")} {
      .MuiAccordion-root.Mui-expanded:first-child {
        margin-top: -5px;
      }
    }
  }
  .AccordionHeaderscroll {
    position: fixed;
    z-index: 999;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
    transition: width 1s;

    @keyframes fadeMe {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    ${(props) => props.theme.breakpoints.down("md")} {
      width: 100%;
    }
    ${(props) => props.theme.breakpoints.between("xs", "md")} {
      top: 48px;
      width: 100% !important;
    }
    ${(props) => props.theme.breakpoints.between("lg", "xl")} {
      .MuiAccordion-root.Mui-expanded:first-child {
        margin-top: -5px;
      }
    }
  }
`;

const StyledLayoutGrid = styled(Grid)`
  width: 100%;
  .MuiPaper-root {
    // width: 100%;
  }
  .MuiTableCell-root {
    padding: 7px;
    border: 1px solid lightgray;
  }
  .MuiToolbar-regular {
    min-height: 0px;
  }
  .MuiTableCell-head {
    background: ${(props) => props.theme.colors.base.buttonGradientFirstColor};
    color: white;
    text-align: center;
    font-weight: 700;
    border: 1px solid lightgray;
    justify-content: center;
  }

  .MuiTableCell-root {
    text-align: center;
  }

  .MuiTableCell-head .MuiButton-root {
    color: white;
    text-align: center;
    font-weight: 700;
  }
  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    .MuiTableCell-root {
      text-align: center;
      max-width: 400px;
      border: none;
    }
    .MuiTableHead-root {
      display: flex !important;
    }
  }
`;
const StyledBtnContainer = styled.div`
  text-align: center;
`;

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 5px;
`;

const StyledCoreDataGridContainer = styled(Grid)``;
const StyledTextWrapper = styled(Grid)`
  margin: auto;
  text-align: center;
`;
const StyledActionBarContainer = styled(Grid)`
  padding: 10px;
  align-items: center;
  margin: 10px 0px 10px 0px;
  border-radius: 5px;
  box-shadow: 2px 0px 5px 2px ${(props) => props.theme.colors.base.lightGrey};
  justify-content: flex-end;
  &:focus {
    outline: none;
  }
`;
const StyledButtonHeader = styled.button`
  color: ${(props) => props.theme.colors.base.white};
  font-size: 1em;
  padding: 0.4em;
  margin: 0.3em;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.base.white};
  background: #2660ad;
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.textColor};
    cursor: pointer;
  }

  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    font-size: 0.8em;
  }
`;

export const StyledPageSizeSelectorContainer = styled.div`
  border: none;
  select {
    padding: 0.4em 0.4em;
    margin: 0em;
    border: none;
    border-radius: 3px;
    font-size: 1em;
    border: 1px solid ${(props) => props.theme.colors.base.lightGrey};
    background: ${(props) => props.theme.colors.base.veryVeryLightGrey};
    color: ${(props) => props.theme.colors.base.black};
    width: 125px;

    ${(props) => props.theme.breakpoints.between("xs", "sm")} {
      padding: 0.2em 0.3em;
      margin: 0.2em;
    }
    background: url("/images/assets/doubledown.png") no-repeat;
    background-position: calc(100% - 0rem) center !important;
    appearance: none !important;
    background-size: 30px 20px;
    cursor: pointer;
  }
`;

interface IProps {
  productCart: any;
  annualData: any;
}

let auctionName: string = "";
let body: any = [];
let totalElement: number = 0;
let page: number = 0;
let testno: number = 100;

let payload: any = {};
let startCount: number = 0;
let endCount: number = 20;
let endCountMob: number = 100;
let rowSelectedData: any;
let updatedRowData: any;
let updateRowIndex: any;
let auctionProductResult: any;
let seconds: any = "";

let filter: any = [];
let filteredValues: any = "";
let filteredParcelValues: any = "";

let length: any;

let mybidAuctionId: any;
let myBidsAuctioneerUserId: any;
//same as Tender auction
const columnIndexes = {
  serialNo: 0,
  productId: 1,
  auctionUserId: 2,
  productCode: 6,
  lab: 7,
  certificate: 8,
  description: 9,
  productDescription: 10,
  carat: 11,
  color: 12,
  remarks: 13,
  noOfPieces: 14,
  shape: 15,
  sieve: 16,
  cutGrade: 17,
  clarity: 18,
  polish: 19,
  symmetryAbbreviation: 20,
  flour: 21,
  currency: 22,
  peicePerCt: 23,
  myLatestBids: 24,
  notes: 25,
  currentBidPrice: 26,
  repnetPrice: 27,
  noOfBids: 28,
  rowColor: 29,
  exchangeRate: 30,
  parcelType: 31,
  noOfBidders: 32,
  currentBidValue: 31,
  hieghestBidValue: 32,
  watched: 33,
  sellerAuctionUserId: 34,
  rapnetPercentage: 35,
  previousHighestBidder: 37,
  productStartDate: 38,
  productExtended: 39,
  holdPreviousBidder: 40,
};

let details: any;
let date: string | string[] = "";
let auctionDate: any;
let indexsForBulkBidItems: any = [];
let myLatestBidForProduct: any = [];
let isAuctionUserId: boolean;
let isReadOnlyUser: any;
let joinedAuctions: any = [];

const initialState = {
  mouseX: null,
  mouseY: null,
};
let SelectedTableData: any;
let timeVal: any = 2000;
const DiamondProductMyBids = (props: IProps) => {
  const { productCart, annualData } = props;

  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableBody: {
          emptyTitle: {
            // maxWidth: "100%",
          },
        },
        MUIDataTableSelectCell: {
          fixedHeader: {
            background: "white",
          },
          fixedLeft: {
            background: "white",
          },
        },
        MuiTableSortLabel: {
          active: {
            color: "green", // your color here
          },
        },
        MUIDataTableHead: {
          responsiveStacked: {
            // display: "flex !important",
          },
        },
      },
    });
  const [mybidProducts, setmybidProducts] = useState<any>([]);
  const [openToast, setOpenToast] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alertType, setAlertType] = useState("");

  const [apiTimeout, setApiTimeout] = useState(false);
  const [onAction, setOnAction] = useState(false);

  const [showTenderSlider, setshowTenderSlider] = useState(false);
  const [showBulkBidPopup, setShowBulkBidPopup] = useState(false);
  const [showBulkBidButton, setShowBulkBidButton] = useState(false);

  const theme = useTheme();
  const notSmallDevices = useMediaQuery(theme.breakpoints.between("md", "xl"));
  const [uiBoxView, setUiBoxView] = useState(false);
  const [isColorDataFilter, setIsColorDataFilter] = useState(false);
  const [isDataRefresh, setIsDataRefresh] = useState(false);
  const [openReadOnlyUserToast, setOpenReadOnlyUserToast] = useState(false);
  const [shouldGetAllData, setShouldGetAllData] = useState(false);
  const [showAllProductButton, setShowAllProductButton] =
    useState<boolean>(false);
  const [currentProductId, setCurrentProductId] = useState<string>("");
  const [productdate, setProductStartDate] = useState<string>("");
  const [mouseState, setMouseState] = React.useState<{
    mouseX: null | number;
    mouseY: null | number;
  }>(initialState);
  const [colorMybidsName, setColorMybidsName] = React.useState<string>("");
  const [totalAmount, setTotalAmount] = React.useState(0);
  const [totalAmountLabel, setTotalAmountLabel] = React.useState<string>("");
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [isBuyItNowModal, setIsBuyItNowModal] = useState(false);
  const [currentProductData, setCurrentProductData] = useState(null);

  const { t } = useTranslation();
  let history = useHistory();
  let isCategoryPageType: any = true;
  const Auth = new AuthService();
  const maxRetryCount = 2;
  const countRef = useRef(0);
  const watchedItemArr: any = useRef<any>();
  const itemsPerPageUseRef = useRef(20);
  const selectPageUseRef = useRef(0);
  const secondTryAnnualRef = useRef(0);
  const maxCallApiCount = 1;
  const countAnnualRef = useRef(0);
  const eventSource: any = useRef<any>();
  const bufferTotalPay = useRef(0);
  const dispatch: AppDispatch = useDispatch();
  let userCurrencyCode = localStorage.getItem("preferredCurrency");
  let userCurrencySymbol = localStorage.getItem("preferredCurrencySymbol");
  const usdBufferTotalPay = useRef(0);
  const isGridView: any = useSelector((state: RootState) =>
    selectGridView(state),
  );

  const isMyBidstab: any = useSelector((state: RootState) =>
    isMyBidstabSelected(state),
  );

  const selectedColor: any = useSelector((state: RootState) =>
    selectedColorFilter(state),
  );

  useEffect(() => {
    dispatch(resetDiamondGridProductIndexes());
    dispatch(resetDiamondSelectAll());
    dispatch(setIsMybids({ isMybidstab: true }));
    isReadOnlyUser = localStorage.getItem("isReadOnlyUser");
    isReadOnlyUser = JSON.parse(isReadOnlyUser);
    localStorage.removeItem("dropDownFilterVal");
    localStorage.removeItem("jwlauctionUserId");

    joinedAuctions = localStorage.getItem("joinedAnnualAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null || joinedAuctions?.length !== undefined) {
      joinedAuctions.filter((items: any, index: number) => {
        if (items.category === "Diamonds") {
          auctionDate = items.startDate;
          mybidAuctionId = items.perId;
          myBidsAuctioneerUserId = items.auctionUserId;
        }
      });
    } else {
      mybidAuctionId = annualData.perId;
      myBidsAuctioneerUserId = annualData.auctionUserId;
      auctionDate = annualData.startDate;
    }
    //data table api calling
    getAllUpdatedData();
    getMyLatestBids(mybidAuctionId);

    setTimeout(() => {
      setIsDataRefresh(!isDataRefresh);
    }, 3000);

    return () => {
      if (eventSource.current !== undefined || eventSource.current !== null) {
        if (eventSource.current?.close !== undefined) {
          eventSource.current?.close();
        }
      }
    };
  }, []);

  useEffect(() => {
    if (shouldGetAllData) {
      getAllUpdatedData();
      setShouldGetAllData(false);
    }
  }, [shouldGetAllData]);

  const getAllUpdatedData = () => {
    if (countRef.current < maxRetryCount) {
      eventSource.current = new EventSource(
        `${getAnnualBidInfo}?auctionId=${mybidAuctionId}`,
      );
      eventSource.current.onmessage = (event: any) => {
        updatedRowData = JSON.parse(event.data);
        if (updatedRowData !== undefined) {
          if (updatedRowData.alive) {
            //This will listen only for events
          } else {
            if (mybidAuctionId === updatedRowData.auctionId) {
              updateRowIndex = auctionProductResult.findIndex(
                (product: any) => product.perId === updatedRowData.perId,
              );
              const mapping: any = {};
              if (
                auctionProductResult !== undefined &&
                auctionProductResult.length > 0
              ) {
                auctionProductResult.map((items: any) => {
                  mapping[items.perId] = {
                    watched: items.watched,
                  };
                });
              }

              var updatedArr: any;
              if (updateRowIndex !== -1) {
                updatedArr = update(auctionProductResult, {
                  $splice: [[updateRowIndex, 1, updatedRowData]],
                });
              }

              var updatedArr: any;
              if (updateRowIndex !== -1) {
                updatedArr = update(auctionProductResult, {
                  $splice: [[updateRowIndex, 1, updatedRowData]],
                });
              } else {
                updatedArr = auctionProductResult;
              }

              const arr = [...updatedArr];
              arr.map((items: any) => {
                if (watchedItemArr.current !== null) {
                  let watchedItemIndex = watchedItemArr.current.findIndex(
                    (product: any) => items.perId === product.productId,
                  );
                  if (mapping[items.perId] !== undefined) {
                    if (watchedItemIndex !== -1) {
                      items.watched =
                        watchedItemArr.current[watchedItemIndex].watched;
                    } else {
                      items.watched = mapping[items.perId].watched;
                    }
                  }
                } else {
                  if (mapping[items.perId] !== undefined) {
                    items.watched = mapping[items.perId].watched;
                  }
                }
              });
              auctionProductResult = updatedArr;
              setmybidProducts(auctionProductResult);
              setShouldGetAllData(false);

              //update total amount of user pay
              bufferTotalPay.current =
                bufferTotalPay.current +
                updatedRowData.liveHighestBidIncreasedBy;
              usdBufferTotalPay.current =
                usdBufferTotalPay.current +
                updatedRowData.liveHighestBidIncreasedByInCurrencies[0].amount;
              if (userCurrencyCode !== "JPY") {
                let conversion = new Intl.NumberFormat("us-en").format(
                  Math.round(usdBufferTotalPay.current),
                );
                let conversions = new Intl.NumberFormat("us-en").format(
                  Math.round(bufferTotalPay.current),
                );
                setTotalAmountLabel(
                  `${updatedRowData.currency.symbol} ${conversions} (${userCurrencySymbol} ${conversion})`,
                );
              } else {
                let conversions = new Intl.NumberFormat("us-en").format(
                  Math.round(bufferTotalPay.current),
                );
                setTotalAmountLabel(`${userCurrencySymbol} ${conversions}`);
              }
            }
          }
        }
      };
      eventSource.current.onerror = (err: any) => {
        console.error("EventSource failed:", err);
        countRef.current = countRef.current + 1;
        setShouldGetAllData(true);
      };
    }
  };

  //Note: Get my All LatestBid using this Api
  const getMyLatestBids = (auctionId: string) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.getRequest(
        `${annualMyLatestBidsForUser}?auctionId=${auctionId}`,
        (status: number, response: any) => {
          if (status === 200) {
            setIsLoading(false);
            myLatestBidForProduct = response;
          } else if (status === 505) {
            setApiTimeout(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage("Internal Server Error");
            setAlertType("error");
            setOpenToast(false);
          }
        },
      );
    }
  };

  const getMyRecentBids = (auctionId: string, productObj: any) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.postRequest(
        `${annualMyRecentBidsForUser}?auctionId=${auctionId}`,
        productObj,
        (status: number, response: any) => {
          if (status === 200) {
            setIsLoading(false);
            let arrayModify = response;
            arrayModify.concat(
              myLatestBidForProduct.filter(
                (x: any) =>
                  !arrayModify.find((m: any) => m.productId === x.productId),
              ),
            );
            setIsSelected(false);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage("Internal Server Error");
            setAlertType("error");
            setOpenToast(false);
          }
        },
      );
    }
  };

  const handleBidClick = (tableData: any) => {
    rowSelectedData = tableData.rowData;
    getProductsDetails(mybidProducts);
    setshowTenderSlider(true);
  };

  const getProductsDetails = (product: any) => {
    length = mybidProducts.length;
    product.map((items: any, index: any) => {
      if (items.perId === rowSelectedData[columnIndexes.productId]) {
        details = index;
      }
    });
    return details;
  };

  const getBoxIndex = (boxIndex: any) => {
    length = mybidProducts.length;
    details = boxIndex;
    setshowTenderSlider(true);
  };

  // bulk bid popup
  const bulkBidPopupHandler = () => {
    setShowBulkBidPopup(true);
  };

  const getTendorMybidsAucProducts = (
    auctionId: number | string,
    currentPage: number,
    isMob: boolean,
  ) => {
    setOpenToast(false);

    body = [];
    filteredValues = "";
    filteredParcelValues = "";

    if (localStorage.getItem("tabSelectedVal") === "1") {
      filteredValues = localStorage.getItem("filteredValues");
      filteredValues = JSON.parse(filteredValues);

      if (filteredValues !== undefined) {
        if (filteredValues === null || filteredValues.length === 0) {
          filter = null;
        } else {
          filteredValues.map((item: any, index: number) => {
            if (item.name === "auctionId") {
              filteredValues.splice(index, 1);
            }
          });
          filter = filteredValues;
        }
      }
    } else {
      filteredParcelValues = localStorage.getItem("filteredParcelValues");
      filteredParcelValues = JSON.parse(filteredParcelValues);

      if (filteredParcelValues !== undefined) {
        if (
          filteredParcelValues === null ||
          filteredParcelValues.length === 0
        ) {
          filter = null;
        } else {
          filteredParcelValues.map((item: any, index: number) => {
            if (item.name === "auctionId") {
              filteredParcelValues.splice(index, 1);
            }
          });
          filter = filteredParcelValues;
        }
      }
    }
    getBody(auctionId, currentPage, endCount, isMob);
  };

  const getTendorMybidsAucProductsFirst = (
    auctionId: number | string,
    currentPage: number,
    isMob: boolean,
  ) => {
    setOpenToast(false);

    body = [];
    filteredValues = "";
    filteredParcelValues = "";

    if (localStorage.getItem("tabSelectedVal") === "1") {
      filteredValues = localStorage.getItem("filteredValues");
      filteredValues = JSON.parse(filteredValues);

      if (filteredValues !== undefined) {
        if (filteredValues === null || filteredValues.length === 0) {
          filter = null;
        } else {
          filteredValues.map((item: any, index: number) => {
            if (item.name === "auctionId") {
              filteredValues.splice(index, 1);
            }
          });
          filter = filteredValues;
        }
      }
    } else {
      filteredParcelValues = localStorage.getItem("filteredParcelValues");
      filteredParcelValues = JSON.parse(filteredParcelValues);

      if (filteredParcelValues !== undefined) {
        if (
          filteredParcelValues === null ||
          filteredParcelValues.length === 0
        ) {
          filter = null;
        } else {
          filteredParcelValues.map((item: any, index: number) => {
            if (item.name === "auctionId") {
              filteredParcelValues.splice(index, 1);
            }
          });
          filter = filteredParcelValues;
        }
      }
    }
    setTimeout(() => {
      getBody(auctionId, currentPage, endCount, isMob);
    }, timeVal);
    if (timeVal <= 15000) {
      timeVal = timeVal + 2000;
    } else {
      timeVal = 2000;
    }
  };

  const getBody = (
    auctionId: string | number,
    currentPage: number,
    endValue: number,
    isMobile: boolean,
    filterValue?: any,
  ) => {
    page = currentPage;
    if (isMobile) {
      startCount = page * endCount;
    } else {
      startCount = page * endValue;
    }

    payload = {};

    if (localStorage.getItem("tabSelectedVal") === "1") {
      filteredValues = localStorage.getItem("filteredValues");
      filteredValues = JSON.parse(filteredValues);
    } else {
      filteredParcelValues = localStorage.getItem("filteredParcelValues");
      filteredParcelValues = JSON.parse(filteredParcelValues);
    }

    if (
      localStorage.getItem("dropDownFilterVal") !== undefined &&
      localStorage.getItem("dropDownFilterVal") !== null
    ) {
      var tempArr = localStorage.getItem("dropDownFilterVal");
      if (tempArr !== null) var dropDownValues = JSON.parse(tempArr);
      var property = dropDownValues[0].property;
      var direction = dropDownValues[0].direction;
    }

    if (localStorage.getItem("annualitemsPerPage") !== null) {
      let savedCount: any = localStorage.getItem("annualitemsPerPage");
      endCount = parseInt(savedCount);
      itemsPerPageUseRef.current = endCount;
    } else {
      endCount = 20;
      itemsPerPageUseRef.current = endCount;
    }

    if (localStorage.getItem("onlyMybidsCurrentStart") !== null) {
      let savedCount: any = localStorage.getItem("onlyMybidsCurrentStart");
      startCount = parseInt(savedCount);
      selectPageUseRef.current = startCount;
    } else {
      startCount = 0;
      selectPageUseRef.current = startCount;
    }

    if (
      (filter === null &&
        (filteredValues == null ||
          filteredValues === undefined ||
          filteredValues === "null" ||
          filteredValues.length === 0)) ||
      (filter === null &&
        (filteredParcelValues == null ||
          filteredParcelValues === undefined ||
          filteredParcelValues === "null" ||
          filteredParcelValues.length === 0))
    ) {
      payload = {
        filters: {
          and: [
            {
              match: "exact",
              name: "auctionId",
              value: auctionId,
            },
          ],
        },
        page: {
          start: isMobile ? startCount : 0,
          count: isMobile ? endCount : isMyBidstab ? 5000 : endValue,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "createdDate",
                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "DESC",
              },
            ],
          },
        },
      };
    } else {
      if (filteredValues !== null && filteredValues.length > 0) {
        body = filteredValues ? filteredValues : filter;
      } else {
        body = filteredParcelValues ? filteredParcelValues : filter;
      }

      body.map((item: any, index: number) => {
        if (item.name === "auctionId") {
          body.splice(index, 1);
        }
      });

      if (localStorage.getItem("tabSelectedVal") === "1") {
        body.push({
          match: "exact",
          name: "auctionId",
          value: mybidAuctionId,
        });
        payload = {
          filters: {
            and: body,
          },
          page: {
            start: isMobile ? startCount : 0,
            count: isMobile ? endCount : isMyBidstab ? 5000 : endValue,
            sort: {
              orders: [
                {
                  property:
                    property !== null && property !== undefined
                      ? property
                      : "createdDate",
                  direction:
                    direction !== null && direction !== undefined
                      ? direction
                      : "DESC",
                },
              ],
            },
          },
        };
      } else {
        let andArr = [];
        andArr.push(
          {
            match: "exact",
            name: "auctionId",
            value: mybidAuctionId,
          },
          {
            match: "exact",
            name: "parcelType",
            value: "Parcel",
          },
        );
        payload = {
          filters: {
            or: body,
            and: andArr,
          },
          page: {
            start: isMobile ? startCount : 0,
            count: isMobile ? endCount : isMyBidstab ? 5000 : endValue,
            sort: {
              orders: [
                {
                  property:
                    property !== null && property !== undefined
                      ? property
                      : "createdDate",
                  direction:
                    direction !== null && direction !== undefined
                      ? direction
                      : "DESC",
                },
              ],
            },
          },
        };
      }
    }
    callApi(payload, filterValue);
  };

  const callApi = (payload: any, filterValue?: any) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.postRequest(
        `${annualMyBidProducts}?auctionId=${mybidAuctionId}&rowColorState=${selectedColor}`,
        payload,
        (status: any, response: any) => {
          setIsLoading(false);
          if (status === 200) {
            totalElement = response.totalElements;
            auctionProductResult = response.results;
            let requestData: any = [];
            setmybidProducts(response.results);

            let totalpay = 0;
            let usdTotalPay = 0;
            //calculate total sum of current Bid Price
            if (
              response.additionalData !== undefined &&
              response.results.length !== 0
            ) {
              let { totalAmount, totalAmountUSD, totalAmountJPY } =
                response.additionalData;
              let { currency } = response.results[0];
              //get auction currency symbol
              usdTotalPay = totalAmountUSD;
              totalpay = totalAmount;
              if (userCurrencyCode !== "USD") {
                let conversion = new Intl.NumberFormat("us-en").format(
                  Math.round(totalAmountJPY),
                );
                let conversions = new Intl.NumberFormat("us-en").format(
                  Math.round(totalAmount),
                );
                setTotalAmountLabel(
                  `${currency.symbol} ${conversions} (${userCurrencySymbol} ${conversion})`,
                );
              } else {
                let conversions = new Intl.NumberFormat("us-en").format(
                  Math.round(totalAmount),
                );
                setTotalAmountLabel(`${currency.symbol} ${conversions}`);
              }
            } else {
              setTotalAmountLabel(`-`);
              setmybidProducts(response.results);
            }

            bufferTotalPay.current = totalpay;
            usdBufferTotalPay.current = usdTotalPay;
            setTotalAmount(totalpay);

            if (response.totalElements >= 100) {
              setShowAllProductButton(true);
            } else {
              setShowAllProductButton(false);
            }
            for (var i = 0; i < response.totalElements; i++) {
              let obj = response.results[i];
              const { auctionUserId, rowColor, previousHighestBidder } = obj;
              if (previousHighestBidder === undefined) {
                if (auctionUserId !== myBidsAuctioneerUserId) {
                  obj["sortingColorCode"] = 113;
                  obj["colorFilter"] = "WHITE";
                } else {
                  if (rowColor === "#FFEB9C") {
                    obj["sortingColorCode"] = 112;
                    obj["colorFilter"] = "ORANGE";
                  } else {
                    obj["sortingColorCode"] = 111;
                    obj["colorFilter"] = "PINK";
                  }
                }
              } else {
                if (myBidsAuctioneerUserId === previousHighestBidder) {
                  obj["sortingColorCode"] = 111;
                  obj["colorFilter"] = "PINK";
                } else {
                  if (rowColor === "#FFEB9C") {
                    obj["sortingColorCode"] = 112;
                    obj["colorFilter"] = "ORANGE";
                  } else {
                    obj["sortingColorCode"] = 111;
                    obj["colorFilter"] = "PINK";
                  }
                }
              }
              requestData.push(obj);
            }
            countAnnualRef.current = 0;
            secondTryAnnualRef.current = 1;
            setmybidProducts(requestData);
            setColorMybidsName(selectedColor);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else if (status === 404) {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setAlertType("error");
            setOpenToast(true);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        },
      );
    }
  };

  const filterColorSort = () => {
    if (!isColorDataFilter) {
      setmybidProducts(
        mybidProducts.sort((a: any, b: any) =>
          a.sortingColorCode > b.sortingColorCode ? 1 : -1,
        ),
      );
    } else {
      setmybidProducts(
        mybidProducts.sort((a: any, b: any) =>
          a.sortingColorCode < b.sortingColorCode ? 1 : -1,
        ),
      );
    }
    setIsColorDataFilter(!isColorDataFilter);
  };

  const handleBtnValue = (
    values: number,
    currentBidPrice: any,
    productId: any,
    myBidValues: any,
  ) => {
    var data = [
      {
        bidIncreasedBy: values,
        bidPrice: currentBidPrice,
        auctionUserId: myBidsAuctioneerUserId,
        auctionId: mybidAuctionId,
        productId: productId,
      },
    ];

    var dataProduct = [productId];

    let updateRowIndex = myLatestBidForProduct.findIndex(
      (product: any) => product.productId === myBidValues.productId,
    );
    if (updateRowIndex === -1) {
      var myLatestBidForProductObjectData: any = [
        ...myLatestBidForProduct,
        myBidValues,
      ];
      myLatestBidForProduct = myLatestBidForProductObjectData;
    } else {
      var updatedArray = update(myLatestBidForProduct, {
        $splice: [[updateRowIndex, 1, myBidValues]],
      });
      myLatestBidForProduct = updatedArray;
    }
    bidProduct(data, dataProduct);
    PubSub.publish("resetAnnualDiamsGridBoxIndex", []);
  };

  const bulkBidHandler = (
    values: any[],
    myBidBulkValues: any,
    productids: any,
  ) => {
    myLatestBidForProduct = myBidBulkValues;
    let obj: any = productids;
    watchedItemArr.current = values;
    bidProduct(values, obj);
    PubSub.publish("resetGridBoxIndex", []);
    onGridSelectionChange(0);
    dispatch(resetDiamondGridProductIndexes());
    dispatch(resetDiamondSelectAll());
    setIsSelected(false);
  };

  const getTableBodyHeight = () => {
    var h = window.innerHeight;
    let heightOfInnerTable = h - 260;
    if (mybidProducts.length > 4) {
      return `${heightOfInnerTable}px`;
    } else {
      return `auto`;
    }
  };

  const options: MUIDataTableOptions = {
    filter: true,
    download: "false",
    print: "false",
    viewColumns: "false",
    count: totalElement,
    serverSide: false,
    search: true,
    sort: true,
    pagination: false,
    rowsPerPage: endCount,
    rowsPerPageOptions: [0],
    selectableRows: "multiple",
    selectableRowsHeader: true,
    selectableRowsOnClick: false,
    isRowSelectable: (dataIndex: any) => {
      const disableRowIndexsArray = getDisableRowIndex();
      return disableRowIndexsArray.includes(dataIndex) ? false : true;
    },
    customToolbarSelect: () => {
      return (
        <div className="mailIconDiv">
          <IconButton color="primary">
            <i className="zmdi zmdi-email"></i>
          </IconButton>
        </div>
      );
    },
    onChangePage: (currentPage: number) => {
      getTendorMybidsAucProducts(mybidAuctionId, currentPage, false);
    },
    setRowProps: (row: any) => {
      if (row[columnIndexes.previousHighestBidder] === undefined) {
        if (row[columnIndexes.holdPreviousBidder] === undefined) {
          if (row[columnIndexes.auctionUserId] !== myBidsAuctioneerUserId) {
            return { style: { background: "white" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        } else {
          if (
            myBidsAuctioneerUserId === row[columnIndexes.holdPreviousBidder]
          ) {
            return { style: { background: "#ffeb9c" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        }
      } else {
        if (
          myBidsAuctioneerUserId === row[columnIndexes.previousHighestBidder]
        ) {
          return { style: { background: "#FBE4D5" } };
        } else {
          return { style: { background: row[columnIndexes.rowColor] } };
        }
      }
    },
    onRowSelectionChange: (
      currentRowsSelected: any,
      allRowsSelected: any,
      rowsSelected: any,
    ) => {
      indexsForBulkBidItems = rowsSelected;
      setOpenToast(false);
      indexsForBulkBidItems.map((indexs: any) => {
        let {
          sellerAuctionUserId,
          previousHighestBidder,
          auctionUserId,
          holdPreviousBidder,
        } = mybidProducts[indexs];
        if (sellerAuctionUserId === myBidsAuctioneerUserId) {
          return { ...options, isRowSelectable: "false" };
        } else if (previousHighestBidder !== undefined) {
          if (myBidsAuctioneerUserId === previousHighestBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (holdPreviousBidder !== undefined) {
          if (myBidsAuctioneerUserId === holdPreviousBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (auctionUserId === myBidsAuctioneerUserId) {
          return { ...options, isRowSelectable: "false" };
        }
      });
      if (indexsForBulkBidItems.length >= 0) {
        setShowBulkBidButton(true);
      } else {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length === 0) {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length > 10) {
        setShowAlertMessage(
          `${t("common:Tender:validation:productSelection")}`,
        );
        setAlertType("error");
        setOpenToast(true);
      }
    },
    tableBodyHeight: getTableBodyHeight(),
    textLabels: {
      body: {
        noMatch: `${t("common:preview:noProductFound")}`,
      },
    },
  };

  const onGridSelectionChange = (rowsSelected: any) => {
    indexsForBulkBidItems = rowsSelected;
    setOpenToast(false);
    if (indexsForBulkBidItems.length >= 0) {
      setShowBulkBidButton(true);
    } else {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length === 0) {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length > 10) {
      setShowAlertMessage(`${t("common:Tender:validation:productSelection")}`);
      setAlertType("error");
      setOpenToast(true);
    }
  };

  const boxColor = (items: any) => {
    const {
      auctionUserId,
      rowColor,
      previousHighestBidder,
      holdPreviousBidder,
    } = items;
    if (previousHighestBidder === undefined) {
      if (holdPreviousBidder === undefined) {
        if (auctionUserId !== myBidsAuctioneerUserId) {
          return "white";
        } else {
          return rowColor;
        }
      } else {
        if (myBidsAuctioneerUserId === holdPreviousBidder) {
          return "#ffeb9c";
        } else {
          return rowColor;
        }
      }
    } else {
      if (myBidsAuctioneerUserId === previousHighestBidder) {
        return "#FBE4D5";
      } else {
        return rowColor;
      }
    }
  };

  const getDisableRowIndex = () => {
    return mybidProducts.map((items: any, index: number) => {
      if (items.sellerAuctionUserId === myBidsAuctioneerUserId) {
        return index;
      } else if (items.previousHighestBidder !== undefined) {
        if (myBidsAuctioneerUserId === items.previousHighestBidder) {
          return index;
        }
      } else if (items.holdPreviousBidder !== undefined) {
        if (myBidsAuctioneerUserId === items.holdPreviousBidder) {
          return index;
        }
      } else if (items.auctionUserId === myBidsAuctioneerUserId) {
        return index;
      }
    });
  };

  const filterSort = (price: any, direction: any) => {
    let order = "";
    if (direction === "asc") {
      order = "desc";
    } else {
      order = "asc";
    }
    sort(price, order);
  };

  const sort = (value: any, direction: any) => {
    sortData(value, direction);
  };

  const sortData = (values: any, direction: any) => {
    let tempArr: any = [{ property: values, direction: direction }];

    if (direction === "asc") {
      tempArr = [{ property: values, direction: "ASC" }];
      localStorage.setItem("dropDownFilterVal", JSON.stringify(tempArr));
    } else {
      tempArr = [{ property: values, direction: "DESC" }];
      localStorage.setItem("dropDownFilterVal", JSON.stringify(tempArr));
    }
    selectPageUseRef.current = 0;
    localStorage.removeItem("currentStart");
    if (localStorage.getItem("onlyMybidsCurrentStart") === null) {
      localStorage.setItem("onlyMybidsCurrentStart", "0");
    } else {
      localStorage.removeItem("onlyMybidsCurrentStart");
    }
    getTendorMybidsAucProducts(mybidAuctionId, 0, true);
  };

  const renderer = ({
    formatted: { days, hours, minutes, seconds },
    completed,
  }: any) => {
    if (completed) {
      if (
        days === "00" &&
        hours === "00" &&
        minutes === "00" &&
        seconds === "00"
      ) {
        getExtendedTime();
        return <span>00:00:00:00</span>;
      }
    } else {
      return (
        <span>
          {days}:{hours}:{minutes}:{seconds}
        </span>
      );
    }
  };
  const getExtendedTime = () => {
    if (!countAnnualRef.current) {
      if (secondTryAnnualRef.current === 0) {
        getTendorMybidsAucProducts(mybidAuctionId, 0, false);
      } else {
        getTendorMybidsAucProductsFirst(mybidAuctionId, 0, false);
      }
      countAnnualRef.current = countAnnualRef.current + 1;
    }
    closebidPopup();
  };

  const getExtendedTimeGrid = (cPage: any) => {
    if (!countAnnualRef.current) {
      if (secondTryAnnualRef.current === 0) {
        getTendorMybidsAucProducts(mybidAuctionId, cPage, true);
      } else {
        getTendorMybidsAucProductsFirst(mybidAuctionId, cPage, true);
      }
      countAnnualRef.current = countAnnualRef.current + 1;
    }
    closebidPopup();
  };

  const productTimeLeft = (startDate: any) => {
    let date: string | null = "";
    let time: string | null = "";
    let timezone: any = "";

    if (startDate !== null || startDate !== undefined) {
      let previewTime = moment.utc(startDate);
      if (timezone !== null) {
        timezone = localStorage.getItem("timezoneName");
      }
      if (previewTime !== null || previewTime !== undefined) {
        let result = moment.tz(previewTime, timezone);
        let resultFormatter = result.format();
        if (resultFormatter !== "Invalid date") {
          let splitDateTime = resultFormatter.split("T", 2);
          let splitTime: any = "";
          if (splitDateTime[1].includes("+")) {
            splitTime = splitDateTime[1].split("+", 2);
          } else {
            splitTime = splitDateTime[1].split("-", 2);
          }
          date = splitDateTime[0];
          time = splitTime[0];
          let dateTime = `${date} ${time}`;
          let end: any = moment(dateTime);
          timezone = localStorage.getItem("timezoneName");
          let start: any = moment(
            new Date().toLocaleString("en-US", { timeZone: timezone }),
          );
          var timeDiff = end - start;
          seconds = Math.round(timeDiff);
        }
      }
    }
    return (
      <Countdown
        date={Date.now() + seconds}
        className="countdownText"
        renderer={renderer}
        zeroPadTime={2}
      />
    );
  };

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "serialNo",
      label: `${t("common:newCommanTrans:serialNo")}`,
      options: {
        filter: true,
        sort: true,
        display: true,
        filterType: "textField",
        sortThirdClickReset: true,
        sortDescFirst: true,
        setCellProps: () => ({
          style: { minWidth: "100px", maxWidth: "100px" },
        }),
      },
    },
    {
      name: "perId",
      label: "Product Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "auctionUserId",
      label: "Auction User Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "buyItNow",
      label: "Buy it now",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          style: {
            background: "#E14843",
            color: "white",
            textAlign: "center",
          },
        }),
        setCellProps: () => ({
          style: { minWidth: "90px", maxWidth: "100px" },
        }),
        customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
          let val: any = mybidProducts[rowIndex];
          return (
            <div>
              <span>
                {convertedbuyItNowValue(
                  val.currency,
                  val.buyItNow,
                  val.exchangeRates[0].rate,
                )}
              </span>
              <StyledBtnContainer>
                {val.buyItNow === 0 ||
                val.sellerAuctionUserId === myBidsAuctioneerUserId ||
                isReadOnlyUser ||
                val.buyItNow < val.currentBidPrice ? (
                  <StyledBuyitNow
                    style={{ color: "black", backgroundColor: "lightgrey" }}
                  >
                    {t("common:newCommanTrans:buyNow")}
                  </StyledBuyitNow>
                ) : (
                  <StyledBuyitNow
                    onClick={() => {
                      setCurrentProductData(val);
                    }}
                  >
                    {t("common:newCommanTrans:buyNow")}
                  </StyledBuyitNow>
                )}
              </StyledBtnContainer>
            </div>
          );
        },
      },
    },
    {
      name: "",
      label: `${t("common:Tender:tableColumnNames:ActionsTender")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                justifyContent: "center",
              }}
            >
              <div
                title={`Note`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  openProductDetail(
                    mybidAuctionId,
                    tableMeta.rowData[1],
                    tableMeta.rowData[columnIndexes.productStartDate],
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faEditProps}
                  style={{ color: "#014a99" }}
                />
              </div>
              <div
                title={`Add Product into Wishlist`}
                style={{ cursor: "pointer" }}
              >
                {isReadOnlyUser ? (
                  <FontAwesomeIcon
                    icon={faHeartProps}
                    style={{ color: "gray" }}
                    onClick={() => {
                      renderReadOnlyUserToast(
                        tableMeta.rowData[columnIndexes.sellerAuctionUserId],
                      );
                    }}
                  />
                ) : (
                  <>
                    {tableMeta.rowData[columnIndexes.sellerAuctionUserId] !==
                    myBidsAuctioneerUserId ? (
                      <>
                        {getWatchedProduct(
                          tableMeta.rowData[columnIndexes.watched],
                          tableMeta.rowData[columnIndexes.productId],
                          mybidAuctionId,
                          tableMeta.rowData[1],
                        )}
                      </>
                    ) : (
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        style={{ color: "gray" }}
                        onClick={() => {
                          renderReadOnlyUserToast(
                            tableMeta.rowData[
                              columnIndexes.sellerAuctionUserId
                            ],
                          );
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <div
                title={`Share Product`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  shareButtonAction(
                    tableMeta.rowData[columnIndexes.productId],
                    tableMeta.rowData[columnIndexes.productStartDate],
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faShareSquareProps}
                  style={{ color: "#014a99" }}
                />
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "productEndDate",
      label: `${t("common:newCommanTrans:timeleft")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "150px", maxWidth: "150px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          if (tableMeta.rowData[columnIndexes.productExtended] !== undefined) {
            if (tableMeta.rowData[columnIndexes.productExtended]) {
              return (
                <span style={{ color: "red" }}>{productTimeLeft(value)}</span>
              );
            } else {
              return <span>{productTimeLeft(value)}</span>;
            }
          }
        },
      },
    },
    {
      name: "code",
      label: `${t("common:Tender:tableColumnNames:productId")}`,
      options: {
        filter: true,
        sort: false,
        filterType: "textField",
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <span
              className="linkCss"
              onClick={() =>
                openProductDetail(
                  mybidAuctionId,
                  tableMeta.rowData[1],
                  tableMeta.rowData[columnIndexes.productStartDate],
                )
              }
              onContextMenu={(event: any) =>
                rightClickEvent(
                  event,
                  tableMeta.rowData[1],
                  tableMeta.rowData[columnIndexes.productStartDate],
                )
              }
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: "lab",
      label: `${t("common:Tender:tableColumnNames:lab")}`,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          if (
            value !== "AGT" &&
            value !== "agt" &&
            value !== "" &&
            value !== undefined
          ) {
            return (
              <span
                className="linkCss"
                onClick={() =>
                  openCertificateLinkPopup(
                    value,
                    tableMeta.rowData[columnIndexes.certificate],
                  )
                }
              >
                {value}
              </span>
            );
          } else {
            return <span>{value}</span>;
          }
        },
      },
    },
    {
      name: "certificate",
      label: `${t("common:Tender:tableColumnNames:certification")}`,
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "description",
      label: `${t("common:Tender:tableColumnNames:description")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
        filterType: "textField",
      },
    },
    {
      name: "productDescription",
      label: "",
      options: {
        filter: true,
        sort: true,
        display: false,
        searchable: true,
      },
    },
    {
      name: "carat",
      label: `${t("common:Tender:tableColumnNames:carat")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "color",
      label: `${t("common:Tender:tableColumnNames:color")}`,
      options: {
        filter: true,
        sort: true,
        display: true,
      },
    },
    {
      name: "remarks",
      label: `${t("common:Tender:tableColumnNames:remark")}`,
      options: {
        filter: true,
        sort: false,
        searchable: true,
        filterType: "textField",
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <EllipsisText
              text={getDescription(
                tableMeta.rowData[columnIndexes.parcelType],
                tableMeta.rowData[columnIndexes.productDescription],
                tableMeta.rowData[columnIndexes.remarks],
              )}
              length={20}
              tail={"..."}
            />
          );
        },
      },
    },
    {
      name: "noOfPieces",
      label: `${t("common:Tender:tableColumnNames:noOfPieces")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any) => {
          return <>{value !== 0 ? value : "-"}</>;
        },
      },
    },
    {
      name: "shape",
      label: `${t("common:Tender:tableColumnNames:shape")}`,
      options: {
        filter: true,
        sort: true,
        display: true,
      },
    },
    {
      name: "sieve",
      label: `${t("common:Tender:tableColumnNames:Sieve")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any) => {
          return <>{value !== "-" ? value : ""}</>;
        },
      },
    },
    {
      name: "cutGrade",
      label: `${t("common:Tender:tableColumnNames:cutGrade")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "clarity",
      label: `${t("common:Tender:tableColumnNames:clarity")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "polish",
      label: `${t("common:Tender:tableColumnNames:polish")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "symmetryAbbreviation",
      label: `${t("common:Tender:tableColumnNames:symmetryAbbreviation")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "flour",
      label: `${t("common:Tender:tableColumnNames:flour")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
      },
    },
    {
      name: "currency",
      label: "currency",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any) => {
          return <div>{value.code}</div>;
        },
      },
    },
    {
      name: "caratMinimumPrice",
      label: `${t("common:Tender:tableColumnNames:pricePct")}`,
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate,
              )}
            </div>
          );
        },
      },
    },
    {
      name: "myLatestBid",
      label: `${t("common:Tender:button:placeBid")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "130px", maxWidth: "140px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {isDataRefresh ? (
                <div>
                  {value === undefined || value === null
                    ? 0
                    : handelMyBidsLabel(
                        myLatestBidForProduct,
                        tableMeta.rowData[columnIndexes.productId],
                        tableMeta.rowData[columnIndexes.currency],
                        tableMeta.rowData[columnIndexes.exchangeRate][0].rate,
                      )}
                </div>
              ) : (
                <div>
                  {value === undefined || value === null
                    ? 0
                    : handelMyBidsLabel(
                        myLatestBidForProduct,
                        tableMeta.rowData[columnIndexes.productId],
                        tableMeta.rowData[columnIndexes.currency],
                        tableMeta.rowData[columnIndexes.exchangeRate][0].rate,
                      )}
                </div>
              )}
              {getBidNowButtonDisable(
                tableMeta.rowData[columnIndexes.sellerAuctionUserId],
                myBidsAuctioneerUserId,
                tableMeta.rowData[columnIndexes.auctionUserId],
                tableMeta,
                getReturnMyLatestStoredBid(
                  myLatestBidForProduct,
                  tableMeta.rowData[columnIndexes.productId],
                ),
                tableMeta.rowData[columnIndexes.currentBidPrice],
                tableMeta.rowData[columnIndexes.productId],
                tableMeta.rowData[columnIndexes.previousHighestBidder],
                tableMeta.rowData[columnIndexes.holdPreviousBidder],
              )}
            </>
          );
        },
      },
    },
    {
      name: "notes",
      label: `${t("common:Tender:tableColumnNames:notes")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "currentBidPrice",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        setCellProps: () => ({
          style: { minWidth: "130px", maxWidth: "140px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate,
              )}
            </div>
          );
        },
      },
    },
    {
      name: "rapnetPercentage",
      label: `${t("common:Tender:tableColumnNames:rapOff")}`,
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {getRapNet(tableMeta.rowData[columnIndexes.rapnetPercentage])}
            </div>
          );
        },
      },
    },
    {
      name: "noOfBidders",
      label: `${t("common:newCommanTrans:noOfBiddersBids")}`,
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { minWidth: "130px", maxWidth: "140px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {getNoOfBiddersAndNoOfBids(
                tableMeta.rowData[columnIndexes.noOfBids],
                tableMeta.rowData[columnIndexes.noOfBidders],
              )}
            </div>
          );
        },
      },
    },
    {
      name: "rowColor",
      label: "Bid Color",
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: "exchangeRates",
      label: "Exchange Rate",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any) => {
          return <div>{value[0].rate}</div>;
        },
      },
    },
    {
      name: "parcelType",
      label: "Category",
      options: {
        filter: true,
        display: false,
      },
    },
    {
      name: "noOfBids",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "watched",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "sellerAuctionUserId",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "rapnetPercentage",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "tenderSecondHighestBid",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate,
              )}
            </div>
          );
        },
      },
    },
    {
      name: "previousHighestBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "productStartDate",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "productExtended",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "holdPreviousBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
  ];

  const renderAutomaticBidPopup = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentProductIdOfBidNow",
    );
    if (rediractProductId !== null) {
      const indexOfProduct = mybidProducts.findIndex(
        (item: any) => item.perId === rediractProductId,
      );
      rowSelectedData = data.rowData;
      SelectedTableData = data.tableData;
      details = indexOfProduct;
      length = mybidProducts.length;
      if (details !== -1) {
        setshowTenderSlider(true);
      }
      localStorage.removeItem("currentProductIdOfBidNow");
    }
  };

  const renderAutomaticBidPopupInMobile = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentProductIdOfBidNow",
    );
    if (rediractProductId !== null) {
      const indexOfProduct = mybidProducts.findIndex(
        (item: any) => item.perId === rediractProductId,
      );
      rowSelectedData = data;
      SelectedTableData = mybidProducts;
      details = indexOfProduct;
      length = mybidProducts.length;
      if (details !== -1) {
        setshowTenderSlider(true);
      }
      localStorage.removeItem("currentProductIdOfBidNow");
    }
  };

  //get bid now button disable
  const getBidNowButtonDisable = (
    sellerId: any,
    auctionUserIdForProduct: any,
    tableAuctionUserId: any,
    tableDataForUIBox: any,
    myBidsForProduct: any,
    currentBidPriceForProduct: any,
    currentproductId: any,
    previousBidderId: any,
    holdPreviousBidder: any,
  ) => {
    renderAutomaticBidPopup(tableDataForUIBox);
    if (isReadOnlyUser) {
      return (
        <StyledBtnContainer
          onClick={() => {
            renderReadOnlyUserToast(sellerId);
          }}
        >
          <StyledButtonGray>
            {t("common:inquiry:button:bidNow")}
          </StyledButtonGray>
        </StyledBtnContainer>
      );
    } else {
      if (sellerId === auctionUserIdForProduct) {
        return (
          <StyledBtnContainer>
            <StyledButtonGray>
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else if (holdPreviousBidder !== undefined) {
        if (myBidsAuctioneerUserId === holdPreviousBidder) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      } else if (previousBidderId !== undefined) {
        if (myBidsAuctioneerUserId === previousBidderId) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      } else if (tableAuctionUserId === myBidsAuctioneerUserId) {
        return (
          <StyledBtnContainer>
            <StyledButtonGray>
              {" "}
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else {
        return (
          <StyledBtnContainer>
            <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
              {t("common:inquiry:button:bidNow")}
            </StyledButton>
          </StyledBtnContainer>
        );
      }
    }
  };

  const handelMyBidsLabel = (
    myStoredBids: any,
    currentProductId: any,
    currency: any,
    exchangeRate: any,
  ) => {
    const Obj = myLatestBidForProduct.filter(
      (item: any) => item.productId === currentProductId,
    );
    const mybidPriceforProduct = Obj.map((item: any) => {
      return item.productId;
    });

    return getMyLatestStoredBids(
      myLatestBidForProduct,
      currentProductId,
      currency,
      exchangeRate,
      mybidPriceforProduct,
    );
  };

  const getWatchedProduct = (
    watched: any,
    productId: any,
    auctionId: any,
    serialNo: any,
  ) => {
    if (watched === true) {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => removeFromWatchlist(productId, auctionId)}
        />
      );
    } else {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "gray", cursor: "pointer" }}
          onClick={() => addToWatchList(productId, auctionId)}
        />
      );
    }
  };

  const shareButtonAction = (perId: any, productStartDate: any) => {
    date = productStartDate.split(" ", 2);
    let languageCode =
      localStorage.getItem("language") === "EN"
        ? "en"
        : localStorage.getItem("language") === "zh_CN"
          ? "zh_CN"
          : "jp";
    copy(
      `${window.location.hostname}/${languageCode}/product/${perId}/${date[0]}/detail`,
    );
    setAlertType("success");
    setOpenToast(true);
    setShowAlertMessage(`${t("common:preview:linkCopied")}`);
    setTimeout(() => {
      setOpenToast(false);
    }, 2000);
  };

  const getNoOfBiddersAndNoOfBids = (noOfBidders: any, noOfBids: any) => {
    return `${noOfBidders}/${noOfBids}`;
  };
  const getDescription = (
    parcelType: any,
    productDescription: any,
    remarks: any,
  ) => {
    if (parcelType === "Diamond") {
      if (remarks !== "" && remarks !== undefined && remarks !== null) {
        return remarks;
      } else {
        return "";
      }
    } else {
      if (
        productDescription !== "" &&
        productDescription !== undefined &&
        productDescription !== null
      ) {
        return productDescription;
      } else {
        return "";
      }
    }
  };

  const openProductDetail = (
    auctionId: string,
    perId: string,
    productStartDate: string,
  ) => {
    date = productStartDate.split(" ", 2);
    history.push(
      `/365products/details/${auctionId}/${myBidsAuctioneerUserId}/${perId}/${date[0]}/${false}`,
    );
    PubSub.publish("resetAnnualDiamsGridBoxIndex", []);
  };

  const openDetailsView = (
    auctionId: string,
    perId: string,
    productStartDate: string,
  ) => {
    date = productStartDate.split(" ", 2);
    window.open(
      `/365products/details/${auctionId}/${myBidsAuctioneerUserId}/${perId}/${date[0]}/${false}`,
      "_blank",
    );
    PubSub.publish("resetAnnualDiamsGridBoxIndex", []);
  };

  const rightClickEvent = (
    event: React.MouseEvent<HTMLDivElement>,
    productId: string,
    productStartDate: string,
  ) => {
    event.preventDefault();
    setMouseState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
    setCurrentProductId(productId);
    setProductStartDate(productStartDate);
  };

  const handleClose = () => {
    setMouseState(initialState);
  };

  const bidProduct = (payloadBid: any, productObj: any) => {
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.postRequest(
        annualBidUrl,
        payloadBid,
        (status: any, response: any) => {
          if (status === 200) {
            setIsDataRefresh(!isDataRefresh);
            getMyRecentBids(mybidAuctionId, productObj);
            let isBidIncreasedBy = payloadBid.some((obj: any) =>
              obj.hasOwnProperty("bidIncreasedBy"),
            );

            if (!isBidIncreasedBy) {
              bulkPrebidCallingApi(payloadBid);
            }
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else if (status === 404) {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setAlertType("error");
            setOpenToast(true);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        },
      );
    }
  };
  const bulkPrebidCallingApi = async (bidobjectarray: any) => {
    const newArr: any = await mybidProducts.map((obj: any) => {
      const bidObj = bidobjectarray.find(
        (bid: any) => bid.productId === obj.perId,
      );
      if (bidObj) {
        return {
          ...obj,
          watched: bidObj.watched,
        };
      }
      return obj;
    });
    setmybidProducts(() => [...newArr]);
  };

  const exportExcel = () => {
    let exportProductIds = mybidProducts.slice(0, 1).map((item: any) => {
      return item.auctionId;
    });
    Auth.postRequestForExcel(
      `${productDownload}?auctionId=${exportProductIds}&auctionType=Annual&auctionProductsType=mybids`,
      { ids: "" },
      (status: any, response: any) => {
        if (status === 200) {
          if (response !== undefined) {
            const url = window.URL.createObjectURL(
              new Blob([response], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }),
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Products.xlsx`);
            document.body.appendChild(link);
            link.click();
          }
        }
      },
    );
  };

  const ShowAllProduct = (auctionId: string | number) => {
    if (uiBoxView) {
      getBody(auctionId, 0, 10000, true);
    } else {
      getBody(auctionId, 0, 10000, false);
    }
  };

  const setItemsPerPageHandler = (itemsPerPage: number) => {
    setCurrentPage(1);
    itemsPerPageUseRef.current = itemsPerPage;
    setItemsPerPage(itemsPerPage);
  };

  function setCurrentPage(currentPage: number) {
    return currentPage;
  }

  function setItemsPerPage(itemsPerPage: number) {
    return itemPerPage(true, 0, itemsPerPage);
  }
  const itemPerPage = (value: boolean, start: number, itemPerPage: number) => {
    if (value === true) {
      localStorage.setItem("annualitemsPerPage", JSON.stringify(itemPerPage));
      getUpdatedProducts(value, start, itemPerPage);
    }
  };

  const getUpdatedProducts = (value: any, start: any, endRecords: any) => {
    if (value === true) {
      getProducts(start, endRecords);
    }
  };

  const getProducts = (start: number, end: number) => {
    startCount = start;
    endCount = end;
    localStorage.setItem("onlyMybidsCurrentStart", JSON.stringify(start));
    let Page: any = localStorage.getItem("currentPageOfTenderAllProducts");
    getBody(mybidAuctionId, parseInt(Page), endCount, true, "ALL");
    PubSub.publish("resetAnnualDiamsGridBoxIndex", []);
    dispatch(resetDiamondGridProductIndexes());
    dispatch(resetDiamondSelectAll());
    onGridSelectionChange(0);
    setIsLoading(true);
  };

  const closebidPopup = () => {
    setshowTenderSlider(false);
    setShowBulkBidPopup(false);

    // PubSub.publish("resetAnnualDiamsGridBoxIndex", []);
  };

  const mypageRedirect = () => {
    localStorage.removeItem("selectedFilterSort");
    history.push("/my-page");
    if (localStorage.getItem("onlyMybidsCurrentStart") === null) {
      localStorage.setItem("onlyMybidsCurrentStart", "0");
    } else {
      localStorage.removeItem("onlyMybidsCurrentStart");
    }
    localStorage.removeItem("annualitemsPerPage");
    PubSub.publish("resetAnnualDiamsGridBoxIndex", []);
  };

  const listGridview = () => {
    selectPageUseRef.current = 0;
    setIsLoading(true);
    if (localStorage.getItem("onlyMybidsCurrentStart") === null) {
      localStorage.setItem("onlyMybidsCurrentStart", "0");
    } else {
      localStorage.removeItem("onlyMybidsCurrentStart");
    }
    localStorage.removeItem("annualitemsPerPage");
    PubSub.publish("resetAnnualDiamsGridBoxIndex", []);
    onGridSelectionChange(0);
    getTendorMybidsAucProducts(mybidAuctionId, 0, true);
    setUiBoxView(true);
    dispatch(setIsGridView({ gridView: true }));
  };

  const Gridview = () => {
    dispatch(resetIsGridView());
    setIsLoading(true);
    getBody(mybidAuctionId, 0, 100, false);
    PubSub.publish("resetAnnualDiamsGridBoxIndex", []);
    onGridSelectionChange(0);
    setUiBoxView(false);
  };

  const handleMyBids = () => {
    //todo
  };

  const renderReadOnlyUserToast = async (perId: any) => {
    var joinedAuctions: any = localStorage.getItem("joinedAnnualAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any) => {
        if (items.category === "Diamonds") {
          if (perId === items.auctionUserId) {
            isAuctionUserId = true;
          }
        }
      });
    } else {
      isAuctionUserId = false;
    }
    await renderPopup();
  };

  const renderPopup = () => {
    if (isReadOnlyUser) {
      setOpenReadOnlyUserToast(true);
    } else if (isAuctionUserId) {
      setOpenReadOnlyUserToast(true);
    } else {
      setOpenReadOnlyUserToast(false);
    }
    setTimeout(() => {
      setOpenReadOnlyUserToast(false);
    }, 3000);
  };

  const addToWatchList = (
    productId: string | number,
    auctionId: string | number,
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (!oAuth()) {
      history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/watch`,
        "payload",
        (status: any, response: any) => {
          if (response !== undefined) {
            if (status === 200) {
              callApi(payload);
              setIsLoading(false);
              setOnAction(false);
              setShowAlertMessage(`${t("common:preview:addedToWatchMsg")}`);
              setAlertType("success");
              setOpenToast(true);
            }
          }
        },
      );
    }
  };

  const removeFromWatchlist = (
    productId: string | number,
    auctionId: string | number,
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (Auth.loggedIn() === null) {
      history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/unwatch`,
        "payload",
        (status: any, response: any) => {
          if (status === 200) {
            callApi(payload);
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response.data.message);
            setAlertType("success");
            setOpenToast(true);
          }
        },
      );
    }
  };

  const colorMybidsFilter = (e: any) => {
    setColorMybidsName(e.target.value);
    const value = e.target.value;
    localStorage.setItem("onlyMybidsCurrentStart", "0");
    // fillterApiCalling(value)
    dispatch(setColorFilter({ color: value }));
  };

  useEffect(() => {
    let innerwidth: any = window.innerWidth;
    setIsLoading(true);
    if (innerwidth > 700) {
      if (isGridView) {
        getTendorMybidsAucProducts(mybidAuctionId, 0, true);
      } else {
        getBody(mybidAuctionId, 0, 100, false);
      }
    } else {
      getTendorMybidsAucProducts(mybidAuctionId, 0, true);
    }
  }, [selectedColor]);

  useEffect(() => {
    let totalpay = 0;
    // return filtred array
    let filtredArr =
      colorMybidsName !== "ALL"
        ? mybidProducts?.filter((x: any) => x.colorFilter === colorMybidsName)
        : mybidProducts;
    //calculate total sum of current Bid Price
    filtredArr?.map((x: any) => {
      totalpay = totalpay + x.currentBidPrice;
    });
    bufferTotalPay.current = totalpay;
    setTotalAmount(totalpay);
  }, [colorMybidsName]);

  const selectAllInGridView = () => {
    //calling select all function in grid View
    let arr: any = [];
    mybidProducts.map((productVal: any, index: any) => {
      if (arr.length < 10) {
        if (isReadOnlyUser) {
          //
        } else {
          if (productVal.sellerAuctionUserId === myBidsAuctioneerUserId) {
            //
          } else if (productVal.holdPreviousBidder !== undefined) {
            if (myBidsAuctioneerUserId === productVal.holdPreviousBidder) {
              //
            } else {
              //add
              arr = [...arr, index];
            }
          } else if (productVal.previousBidderId !== undefined) {
            if (myBidsAuctioneerUserId === productVal.previousBidderId) {
              //
            } else {
              //add
              arr = [...arr, index];
            }
          } else if (productVal.auctionUserId === myBidsAuctioneerUserId) {
            //
          } else {
            if (productVal.auctionUserId === myBidsAuctioneerUserId) {
              //
            } else {
              //add
              arr = [...arr, index];
            }
          }
        }
      }
    });

    if (isSelected) {
      setIsSelected(false);
      PubSub.publish("resetAnnualDiamsGridBoxIndex", []);
      arr = [];
      dispatch(resetDiamondGridProductIndexes());
      dispatch(resetDiamondSelectAll());
    } else {
      setIsSelected(true);
      dispatch(setDiamondGridProductIndexes({ indexes: arr }));
      dispatch(setDiamondSelectAll({ isSelected: true }));
    }
  };

  // buy it now button condition
  useEffect(() => {
    if (currentProductData !== null) {
      setIsBuyItNowModal(true);
    }
  }, [!currentProductData]);

  const renderBuyItNowConfirmationModal = () => {
    return (
      <StyledModal
        open={isBuyItNowModal}
        onClose={() => {
          setIsBuyItNowModal(false);
          setCurrentProductData(null);
        }}
      >
        <BuyItNowconfirmation
          closeModal={() => {
            setCurrentProductData(null);
            setIsBuyItNowModal(false);
          }}
          itemDetails={currentProductData}
          auctionUserId={myBidsAuctioneerUserId}
        />
      </StyledModal>
    );
  };

  const bulkWatchlistHandler = () => {
    if (!isReadOnlyUser) {
      if (indexsForBulkBidItems.length > 0) {
        setShowBulkBidPopup(true);
      } else {
        setShowAlertMessage(t("common:newCommanTrans:buyitnow:toastmsg"));
        setAlertType("error");
        setOpenToast(true);
        setTimeout(() => {
          setOpenToast(false);
        }, 2000);
      }
    } else {
      setShowAlertMessage(`You are the read only user.`);
      setAlertType("error");
      setOpenToast(true);
      setTimeout(() => {
        setOpenToast(false);
      }, 3000);
    }
  };

  return (
    <StyledLayoutGrid>
      {isLoading === true ? (
        <div className="loader">
          <LoadingSpinner />
        </div>
      ) : (
        <StyledLayoutGridMain>
          <StyledLayoutGrid item={true} xs={12}>
            <StyledHeaderContainer container={true} spacing={0}>
              <StyledCoreDataGridContainer container={true} spacing={0}>
                <StyledActionBarContainer
                  container={true}
                  spacing={0}
                  className="coreActionBarContainer"
                >
                  <StyledContainer>
                    <StyledPageSizeSelectorContainer>
                      <select
                        name="sortingControl"
                        onChange={colorMybidsFilter}
                        value={colorMybidsName}
                      >
                        <option value="ALL">MY BIDS</option>
                        <option value="ALL">
                          {t("common:colorFilter:all")}
                        </option>
                        <option value="PINK">
                          {t("common:colorFilter:pink")}
                        </option>
                        <option value="ORANGE">
                          {t("common:colorFilter:orange")}
                        </option>
                        <option value="WHITE">
                          {t("common:colorFilter:white")}
                        </option>
                      </select>
                    </StyledPageSizeSelectorContainer>
                    {notSmallDevices ? (
                      <>
                        {isGridView === true ? (
                          <StyledSelectAllButtonHeader
                            onClick={selectAllInGridView}
                          >
                            {t("common:newCommanTrans:selectAll")}
                          </StyledSelectAllButtonHeader>
                        ) : null}
                      </>
                    ) : (
                      <StyledSelectAllButtonHeader
                        onClick={selectAllInGridView}
                      >
                        {t("common:newCommanTrans:selectAll")}
                      </StyledSelectAllButtonHeader>
                    )}

                    {notSmallDevices ? (
                      <>
                        {isGridView === true ? (
                          <MybidsAnnualActionPageSize
                            setItemsPerPageHandler={setItemsPerPageHandler}
                            t={t}
                          />
                        ) : null}
                      </>
                    ) : (
                      <MybidsAnnualActionPageSize
                        setItemsPerPageHandler={setItemsPerPageHandler}
                        t={t}
                      />
                    )}
                  </StyledContainer>
                  <StyledContainer>
                    <StyledButtonHeader onClick={productCart}>
                      {t("common:newCommanTrans:Cart")}
                    </StyledButtonHeader>

                    <StyledButtonHeader onClick={mypageRedirect}>
                      {t("common:newCommanTrans:myPage")}
                    </StyledButtonHeader>
                    <StyledIconImg
                      src="/images/assets/iconDownload.png"
                      alt="exportsheet"
                      title="Download Export"
                      onClick={exportExcel}
                    />
                    <StyledIconImg
                      src="/images/assets/bidIcon.png"
                      alt="bidIcon"
                      title="Select items to bulk prebid or watchlist"
                      onClick={bulkWatchlistHandler}
                    />

                    {notSmallDevices ? (
                      <>
                        {isGridView === true ? (
                          <StyledIconImg
                            src="/images/assets/listViewIcon.png"
                            onClick={Gridview}
                            className="icon"
                            title="List view of Product"
                          />
                        ) : (
                          <StyledIconImg
                            src="/images/assets/gridViewIcon.png"
                            onClick={listGridview}
                            title="Grid view of Product"
                            className="icon"
                          />
                        )}
                      </>
                    ) : null}
                    <StyledButtonViewFilter onClick={filterColorSort}>
                      <ColorLensIcon />
                    </StyledButtonViewFilter>
                  </StyledContainer>
                </StyledActionBarContainer>
              </StyledCoreDataGridContainer>
            </StyledHeaderContainer>
            <div style={{ float: "right", width: "100%", display: "flex" }}>
              {t("common:newCommanTrans:totalAmounts")}:{" "}
              <span style={{ color: "green" }}>{totalAmountLabel}</span>
            </div>

            <div>
              {mybidProducts.length > 0 ? (
                <>
                  {isGridView === false && notSmallDevices && (
                    <MuiThemeProvider theme={getMuiTheme()}>
                      <MUIDataTable
                        title={""}
                        data={mybidProducts}
                        columns={columns}
                        options={options}
                      />
                    </MuiThemeProvider>
                  )}

                  {isGridView === true
                    ? notSmallDevices && (
                        <>
                          <ProductGridDataParentMybids
                            t={t}
                            data={mybidProducts}
                            totalElements={totalElement}
                            itemPerPage={itemPerPage}
                            value={getUpdatedProducts}
                            noProductFound={handleMyBids}
                            itemsPerPageUseRef={itemsPerPageUseRef.current}
                            selectPageUseRef={selectPageUseRef.current}
                          >
                            {mybidProducts.length > 0 ? (
                              <ProductGridDataChildComponentMyBids
                                {...props}
                                watchlist={addToWatchList}
                                setShowBidPopupBidModal={getBoxIndex}
                                isCategoryPageType={isCategoryPageType}
                                auctionName={""}
                                auctionDate={date[0]}
                                t={t}
                                isAuctionPage={true}
                                boxColor={boxColor}
                                unWatchlist={removeFromWatchlist}
                                auctionUserId={myBidsAuctioneerUserId}
                                sortingValue={filterSort}
                                bulkBidIndexHandler={onGridSelectionChange}
                                myForProductAllProduct={myLatestBidForProduct}
                                renderAutomaticBidPopupInMobile={
                                  renderAutomaticBidPopupInMobile
                                }
                                renderReadOnlyUserToast={
                                  renderReadOnlyUserToast
                                }
                                isRefreshData={getExtendedTimeGrid}
                                rightClickEvent={rightClickEvent}
                              />
                            ) : (
                              <Grid container={true} spacing={0}>
                                <StyledTextWrapper item xs={12}>
                                  {t("common:preview:noProductFound")}
                                </StyledTextWrapper>
                              </Grid>
                            )}
                          </ProductGridDataParentMybids>
                        </>
                      )
                    : null}

                  {notSmallDevices || (
                    <>
                      <ProductGridDataParentMybids
                        t={t}
                        data={mybidProducts}
                        totalElements={totalElement}
                        itemPerPage={itemPerPage}
                        value={getUpdatedProducts}
                        noProductFound={handleMyBids}
                        itemsPerPageUseRef={itemsPerPageUseRef.current}
                        selectPageUseRef={selectPageUseRef.current}
                      >
                        {mybidProducts.length > 0 ? (
                          <ProductGridDataChildComponentMyBids
                            {...props}
                            watchlist={addToWatchList}
                            setShowBidPopupBidModal={getBoxIndex}
                            isCategoryPageType={isCategoryPageType}
                            auctionName={auctionName}
                            auctionDate={date[0]}
                            t={t}
                            isAuctionPage={true}
                            boxColor={boxColor}
                            unWatchlist={removeFromWatchlist}
                            auctionUserId={myBidsAuctioneerUserId}
                            sortingValue={filterSort}
                            bulkBidIndexHandler={onGridSelectionChange}
                            myForProductAllProduct={myLatestBidForProduct}
                            renderAutomaticBidPopupInMobile={
                              renderAutomaticBidPopupInMobile
                            }
                            renderReadOnlyUserToast={renderReadOnlyUserToast}
                            isRefreshData={getExtendedTimeGrid}
                            rightClickEvent={rightClickEvent}
                          />
                        ) : (
                          <Grid container={true} spacing={0}>
                            <StyledTextWrapper item xs={12}>
                              {t("common:preview:noProductFound")}
                            </StyledTextWrapper>
                          </Grid>
                        )}
                      </ProductGridDataParentMybids>
                    </>
                  )}

                  {notSmallDevices ? (
                    <>
                      {isGridView === false && (
                        <StyeldShowAllcontainer container={true} spacing={0}>
                          {showAllProductButton ? (
                            <StyledshowAllButton>
                              <StyledButton
                                onClick={() => ShowAllProduct(mybidAuctionId)}
                              >
                                {t("common:Tender:button:showAll")}
                              </StyledButton>
                            </StyledshowAllButton>
                          ) : (
                            <></>
                          )}
                        </StyeldShowAllcontainer>
                      )}
                    </>
                  ) : null}
                </>
              ) : (
                <Grid
                  container={true}
                  spacing={0}
                  style={{ marginTop: "20px" }}
                >
                  {notSmallDevices ? (
                    <MuiThemeProvider theme={getMuiTheme()}>
                      <MUIDataTable
                        title={""}
                        data={mybidProducts}
                        columns={columns}
                        options={options}
                      />
                    </MuiThemeProvider>
                  ) : (
                    <StyledTextWrapper item xs={12}>
                      {t("common:preview:noProductFound")}
                    </StyledTextWrapper>
                  )}
                </Grid>
              )}
            </div>
            <Menu
              keepMounted
              open={mouseState.mouseY !== null}
              onClose={handleClose}
              anchorReference="anchorPosition"
              anchorPosition={
                mouseState.mouseY !== null && mouseState.mouseX !== null
                  ? { top: mouseState.mouseY, left: mouseState.mouseX }
                  : undefined
              }
            >
              <MenuItem
                onClick={() =>
                  openDetailsView(mybidAuctionId, currentProductId, productdate)
                }
              >
                Details
              </MenuItem>
            </Menu>

            {openToast === true && (
              <Alert
                showAlertMessage={showAlertMessage}
                alertType={alertType}
              />
            )}

            {onAction === true && (
              <div className="loading">
                <LoadingSpinner />
              </div>
            )}

            {/* {showTenderSlider === true && (
              <StyledModal open={showTenderSlider} onClose={closebidPopup}>
                <ProductBiddingUi
                  {...props}
                  items={mybidProducts}
                  currentIndex={details}
                  PopupClose={closebidPopup}
                  handleBtnValue={handleBtnValue}
                  auctionDate={date[0]}
                  totalElements={totalElement}
                  endCount={endCount}
                  auctionUserId={myBidsAuctioneerUserId}
                  length={length}
                  watchedFunction={addToWatchList}
                  unwatched={removeFromWatchlist}
                  boxColor={boxColor}
                  myLatestBidForProduct={myLatestBidForProduct}
                />
              </StyledModal>
            )}
            {showBulkBidPopup === true && ( */}
            {/* <StyledModal open={showBulkBidPopup} onClose={closebidPopup}>
                <AnnualBidPopup
                  {...props}
                  items={mybidProducts}
                  popupClose={closebidPopup}
                  handleBtnValue={bulkBidHandler}
                  auctionUserId={myBidsAuctioneerUserId}
                  length={length}
                  productIndexs={indexsForBulkBidItems}
                  myLatestBidForProducts={myLatestBidForProduct}
                  isJewellery={false}
                />
              </StyledModal>
            )} */}
            {openReadOnlyUserToast === true && (
              <AlertReadOnlyUser
                isReadOnlyUser={isReadOnlyUser}
                isSeller={isAuctionUserId}
              />
            )}
            {isBuyItNowModal &&
              currentProductData !== null &&
              renderBuyItNowConfirmationModal()}
          </StyledLayoutGrid>
        </StyledLayoutGridMain>
      )}
    </StyledLayoutGrid>
  );
};

export default DiamondProductMyBids;
